
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 7.25h14M9 4.625V2M4.625 4.625V2m8.75 2.625V2m-10.5 14h12.25a.875.875 0 00.875-.875v-10.5a.875.875 0 00-.875-.875H2.875A.875.875 0 002 4.625v10.5a.875.875 0 00.875.875z","stroke":"currentColor","stroke-width":"1.867","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    